import { useEffect } from 'react';
import { LanguageLabels } from '@/constants/recommendation';
import { Language } from '@/models/recommendation';
import { ProfileStepIds } from '@/models/recommendation';
import { SelectQuestion } from '@/packages/profile-quiz/components/questions/select-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const LanguagesStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();

  useEffect(() => {
    const hasAtLeastOneLanguage = (answers.languages?.length ?? 0) > 0;
    setCurrentStepValid(hasAtLeastOneLanguage);
  }, [answers.languages, setCurrentStepValid]);

  const handleToggleLanguage = (language: Language) => {
    if (answers.languages?.includes(language)) {
      setQuizAnswer(
        ProfileFields.Languages,
        answers.languages?.filter((l) => l !== language)
      );
    } else {
      setQuizAnswer(ProfileFields.Languages, [
        ...(answers.languages ?? []),
        language,
      ]);
    }
  };

  return (
    <SelectQuestion
      questionTitle="🌎 Você quer aprender ou se aprofundar em quais idiomas?"
      questionId={ProfileStepIds.Languages}
      processedResponseText="Excelente, dominar outros idiomas fortalece tanto a vida profissional quanto a pessoal."
      options={Object.values(Language).map((language) => ({
        label: LanguageLabels[language],
        value: language,
      }))}
      handleToggleAnswer={handleToggleLanguage}
      currentValues={answers.languages}
    />
  );
};
